<template>
	<Page class="dark-primary">
		<template v-slot:content>
			<SafeAreaTop :show-close="false">
				<div class="container mt-10vh">
					<Title class="title centered">
						{{ title }}
					</Title>
					<Subtitle v-if="subtitle" class="subtitle centered mt-1rem mb-3rem">
						{{ subtitle }}
					</Subtitle>
					<SurveySelect :options="options" @change="onChange" type="single" theme="light large" class="mb-xl" />
				</div>
			</SafeAreaTop>
		</template>

		<template v-slot:footer>
			<div class="container">
				<a v-if="skip" class="btn btn-link btn-block text-primary" href="" @click.prevent="skipSurvey">
					{{ skip.text }}
				</a>
			</div>
		</template>
	</Page>
</template>

<script setup>
import { computed, inject, onMounted } from '@vue/runtime-core'
import Title from '@/components/survey/Title'
import Subtitle from '@/components/survey/Subtitle'
import Page from '@/components/Page'
import SurveySelect from '@/components/SurveySelect'
import SafeAreaTop from '@/components/SafeAreaTop'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import useConfig from '@/composition/config'

const props = defineProps({
	title: {
		type: String,
		required: true
	},
	subtitle: {
		type: String,
		default: null
	},
	property: {
		type: String,
		required: true
	},
	options: {
		type: Array,
		required: true,
		default: () => []
	},
	skip: {
		type: Object,
		default: () => ({})
	},
	eventDone: {
		type: String,
		required: true
	},
	eventView: {
		type: String,
		required: true
	},
	nextRouteName: {
		type: String,
		required: true
	}
})

const config = useConfig()
const amplitude = inject('amplitude')
const router = useRouter()
const store = useStore()

const options = computed(() => {
	return store.getters['survey/getProperty']({
		key: props.property,
		options: props.options
	})
})

const selected = computed(() => options.value.filter((option) => option.selected))

function next(data) {
	amplitude.logEvent(props.eventDone, {
		data
	})

	router.push({ name: props.nextRouteName })
}
function onChange(option) {
	store.commit('survey/update', {
		property: props.property,
		value: option
	})

	setTimeout(() => {
		next(selected.value.map((option) => option.value))
	}, 500)
}

function skipSurvey() {
	next([props.skip.key])
}

onMounted(() =>
	amplitude.logEvent('ScreenView', {
		title: props.eventView
	})
)
</script>
